import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import pdfjsWorker from 'pdfjs-dist/legacy/build/pdf.worker.entry';

class ParserHelper {
    readPdfFile(file) {
        if (file.type !== "application/pdf") {
            throw new Error("File is not a PDF");
        }

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = async () => {
                const arrayBuffer = reader.result;
                const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

                const extractTextPromises = [];
                for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                    extractTextPromises.push(
                        pdf.getPage(pageNum).then((page) => {
                            return page.getTextContent().then((textContent) => {
                                const strings = textContent.items.map((item) => item.str);
                                return strings.join('\n');
                            });
                        })
                    );
                }

                const pagesText = await Promise.all(extractTextPromises);
                const textContent = pagesText.join('\n');

                resolve(textContent);
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsArrayBuffer(file);
        });
    }
}

let helper = new ParserHelper
global.ParserHelper = helper
export default helper